<template>
  <div class="ProgressBar">
    <div
      class="ProgressBar-filledBar"
      :style="{ transform: `translate3d(-${(1 - progress) * 100}%, 0, 0)` }"
    ></div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";

import "@/components/ProgressBar/ProgressBar.scss";

export default {
  name: "ProgressBar",
  data () {
    return {
      progress: 0,
    };
  },

  methods: {
    handleScroll () {
      const progress =
        window.scrollY /
        (document.documentElement.scrollHeight - document.documentElement.clientHeight);
      if (progress > 1) {
        this.progress = 1;
      } else if (progress < 0) {
        this.progress = 0;
      } else {
        this.progress = progress;
      }
    },
  },

  created () {
    this.handleDebouncedScroll = debounce(this.handleScroll, 10);
    window.addEventListener("scroll", this.handleDebouncedScroll);
  },

  beforeDestroy () {
    window.removeEventListener("scroll", this.handleDebouncedScroll);
  },
};
</script>
